import { Blueprint, BlueprintVisibility, BlueprintSource, Transaction } from 'types/rest/assetCatalogTypes';

export type BlueprintSourceFilter = BlueprintSource | 'ALL';
export type BlueprintViewMode = 'GRID' | 'LIST';

export interface BlueprintsFilter {
  source: BlueprintSourceFilter;
  searchTerm: string;
  tags: string[];
}

export interface BlueprintDraft {
  id: string | null; // null when creating
  name: string;
  description: string;
  version: string;
  tags: string[];
  thumbnail: string;
  transactionIds: number[];
  visibility: BlueprintVisibility;
}

export interface BlueprintEditorState {
  open: boolean;
  draft: BlueprintDraft | null;
}

export interface BlueprintsState {
  blueprints: Blueprint[];
  availableTransactions: Transaction[];
  isLoading: boolean;
  detailLoading: boolean;
  viewMode: BlueprintViewMode;
  filter: BlueprintsFilter;
  editor: BlueprintEditorState;
  applyBlueprintId: string | null;
  detailBlueprintId: string | null;
  page: number;
  pageSize: number;
  total: number;
}

export const emptyDraft: BlueprintDraft = {
  id: null,
  name: '',
  description: '',
  version: '1.0.0',
  tags: [],
  thumbnail: '',
  transactionIds: [],
  visibility: 'PRIVATE',
};
